import { Link } from 'react-router-dom';
import type { FC } from 'react';
import { videos } from '@/mocks/videos';

const PopularSection: FC = () => {
  const hotVideos = videos.filter(v => v.isHot).slice(0, 8);
  const newVideos = videos.filter(v => v.isNew).slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-100/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        {/* Hot Ranking */}
        <div className="mb-12">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-2">
              <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
              <h2 className="text-lg font-heading font-semibold text-foreground-100">
                热门推荐
              </h2>
              <i className="ri-fire-fill text-primary-400 text-lg"></i>
            </div>
            <Link
              to="/category/drama"
              className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              查看更多 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
            {hotVideos.map((video, index) => (
              <Link
                key={video.id}
                to={`/article/${video.id}`}
                className="group flex items-center gap-3 bg-background-50 rounded-lg p-3 cursor-pointer hover:bg-background-200/50 transition-colors duration-200"
              >
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                  <span className={`text-lg font-heading font-bold ${
                    index < 3 ? 'text-primary-400' : 'text-foreground-500'
                  }`}>
                    {index + 1}
                  </span>
                </div>
                <div className="flex-shrink-0 w-12 h-16 rounded overflow-hidden">
                  <img
                    src={video.cover}
                    alt={video.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-1">
                    {video.title}
                  </p>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-accent-400">{video.rating}</span>
                    <span className="text-xs text-foreground-500">{video.subCategory}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Latest */}
        <div>
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-2">
              <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
              <h2 className="text-lg font-heading font-semibold text-foreground-100">
                最新上线
              </h2>
              <i className="ri-sparkling-2-fill text-accent-400 text-lg"></i>
            </div>
            <Link
              to="/category/movie"
              className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              查看更多 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
            {newVideos.map((video) => (
              <Link
                key={video.id}
                to={`/article/${video.id}`}
                className="group block cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-lg aspect-video mb-3">
                  <img
                    src={video.cover}
                    alt={video.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-transparent to-transparent"></div>
                  <div className="absolute bottom-2 left-2 right-2">
                    <p className="text-xs font-medium text-foreground-50 line-clamp-1">{video.title}</p>
                  </div>
                  <div className="absolute top-2 left-2">
                    <span className="px-2 py-0.5 text-xs rounded bg-accent-500/90 text-background-950 whitespace-nowrap font-medium">
                      NEW
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PopularSection;